var map = {
	"./tags/arch/indoor/bathroom.yaml": 4745,
	"./tags/arch/indoor/bedroom.yaml": 6417,
	"./tags/arch/indoor/color.yaml": 4531,
	"./tags/arch/indoor/dining_room.yaml": 9190,
	"./tags/arch/indoor/environment.yaml": 9305,
	"./tags/arch/indoor/function.yaml": 6097,
	"./tags/arch/indoor/furniture.yaml": 7445,
	"./tags/arch/indoor/home_office.yaml": 4941,
	"./tags/arch/indoor/kitchen.yaml": 1519,
	"./tags/arch/indoor/lounge.yaml": 4772,
	"./tags/arch/indoor/outdoor.yaml": 1641,
	"./tags/arch/outdoor/architect.yaml": 419,
	"./tags/arch/outdoor/detail.yaml": 1117,
	"./tags/arch/outdoor/entourage.yaml": 9797,
	"./tags/arch/outdoor/function.yaml": 1489,
	"./tags/arch/outdoor/height.yaml": 6925,
	"./tags/arch/outdoor/landscape.yaml": 8151,
	"./tags/arch/outdoor/scene.yaml": 7608,
	"./tags/arch/outdoor/style.yaml": 6833,
	"./tags/arch/outdoor/view.yaml": 2931,
	"./tags/artistic-license.yaml": 1224,
	"./tags/characters.yaml": 7462,
	"./tags/human/actions.yaml": 1379,
	"./tags/human/body_ornament.yaml": 7905,
	"./tags/human/breasts.yaml": 9154,
	"./tags/human/clothes.yaml": 7848,
	"./tags/human/directions.yaml": 8892,
	"./tags/human/ears.yaml": 3630,
	"./tags/human/face.yaml": 4848,
	"./tags/human/hair.yaml": 307,
	"./tags/human/head_ornament.yaml": 7294,
	"./tags/human/humantype.yaml": 2247,
	"./tags/human/lowerbody.yaml": 9500,
	"./tags/human/neck.yaml": 4393,
	"./tags/human/quality.yaml": 8645,
	"./tags/human/shoesock.yaml": 8395,
	"./tags/human/upperbody.yaml": 2103,
	"./tags/humanities/buildings.yaml": 7953,
	"./tags/humanities/cities.yaml": 1804,
	"./tags/humanities/food/breads.yaml": 7284,
	"./tags/humanities/food/condiments.yaml": 1247,
	"./tags/humanities/food/dairy.yaml": 4132,
	"./tags/humanities/food/drink.yaml": 3477,
	"./tags/humanities/food/fruit.yaml": 7944,
	"./tags/humanities/food/meal.yaml": 1482,
	"./tags/humanities/food/meat.yaml": 2317,
	"./tags/humanities/food/sweets.yaml": 3568,
	"./tags/humanities/food/vegetable.yaml": 6768,
	"./tags/humanities/indoors.yaml": 5625,
	"./tags/humanities/outdoors.yaml": 6670,
	"./tags/image-composition/articles.yaml": 4213,
	"./tags/image-composition/background.yaml": 9685,
	"./tags/image-composition/censorship.yaml": 7038,
	"./tags/image-composition/color.yaml": 3158,
	"./tags/image-composition/composition.yaml": 7166,
	"./tags/image-composition/effects.yaml": 2149,
	"./tags/image-composition/format.yaml": 3772,
	"./tags/image-composition/perspective.yaml": 1176,
	"./tags/image-composition/style.yaml": 2150,
	"./tags/items.yaml": 4879,
	"./tags/natural/flowers.yaml": 9142,
	"./tags/natural/outdoors.yaml": 7519,
	"./tags/natural/sky.yaml": 359,
	"./tags/restricted/r18-t1.yaml": 5378,
	"./tags/restricted/r18-t2.yaml": 3538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5266;